import { render } from "./VersionPoller.vue?vue&type=template&id=2c3403a9&scoped=true"
import script from "./VersionPoller.vue?vue&type=script&lang=js"
export * from "./VersionPoller.vue?vue&type=script&lang=js"

import "./VersionPoller.vue?vue&type=style&index=0&id=2c3403a9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c3403a9"]])

export default __exports__